import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings } from "@solveindustrial/Utilities/variables";

export const textField: RecursivePartial<{
    defaultProps?: TextFieldPresentationProps | undefined;
}> = {
    defaultProps: {
        iconProps: {
            color: colorStrings.primaryMain,
        },
    },
};
